import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// JanMichaels Art & Home (b_2fsrwhi2m7, advertiser -7838084025975935015).
// Lifetime complete-month metrics through Aug 2026.
export const advJanmichaels: FaireAdvertiserProfileEntity = {
  token: "adv_janmichaels",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "JanMichaels Art & Home",
  brandToken: "b_2fsrwhi2m7",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 27,
  budget: {
    totalBudgetDollars: 8800,
    sharedBudgetDollars: 8800,
    spendingMode: "COMPETITIVE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 372,
    numReorderConversions: 101,
    numTotalConversions: 473,
    totalAdsSalesDollars: 306465,
    newCustomerAdsSalesDollars: 254058,
    reorderAdsSalesDollars: 52407,
    totalAdsSpendDollars: 40383,
    newCustomerAdsSpendDollars: 36012,
    reorderAdsSpendDollars: 4371,
    newCustomerBestEstimateFirstYearRoas: 6.89,
    reorderRoas: 11.99,
    combinedFirstYearRoas: 7.45,
    numNewCustomerAdsOrders: 824,
    numReorderAdsOrders: 113,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 7000,
      maxRecommendedBudgetDollars: 9000,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 700,
      maxRecommendedBudgetDollars: 1400,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_jm_new", "camp_jm_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
